import React, { Component,  } from 'react'
import PropTypes from 'prop-types';
import Responsive from '../Responsive'

export class LayoutOuter extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    style: PropTypes.object,
    dimensions: PropTypes.object
  }

  static defaultProps = {
    style: {},
    dimensions: {}
  }


  static styles = {
    mobile: {
      display: 'flex',           /* establish flex container */
      flexDirection: 'row',  /* make main axis vertical */
    },
    desktop: {
      display: 'flex',           /* establish flex container */
      flexDirection: 'row',  /* make main axis vertical */
      justifyContent: 'flex-start', /* center items vertically, in this case */
      flexBasis: '100%',
      flexWrap: 'nowrap',
      width: '100%',
      background: '#fafafa',
      paddingLeft: '20px',
      paddingRight: '20px',
      paddingTop: '40px',
      paddingBottom: '40px'
    }
  }

  get style(){
    return this.props.dimensions.narrow ?
      LayoutOuter.styles.mobile :
      LayoutOuter.styles.desktop
  }

  render = () =>
    <div style={{...this.style, ...this.props.style}}>
      {this.props.children}
    </div>
}

export default Responsive(LayoutOuter)
